import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e319b7e")

_pushScopeId("data-v-7e319b7e")
const _hoisted_1 = { class: "flex flex-wrap pt-3 p-8 pb-0" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex flex-wrap" }
const _hoisted_4 = { class: "overtime-container" }
const _hoisted_5 = { class: "overtime-header" }
const _hoisted_6 = { class: "overtime__desc" }
const _hoisted_7 = { class: "stamp-box" }
const _hoisted_8 = { class: "target-date" }
const _hoisted_9 = { class: "target-date__desc" }
const _hoisted_10 = { class: "target-date__time" }
const _hoisted_11 = { class: "work-place" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "work-place__desc" }, null, -1)
const _hoisted_13 = { class: "table table-auto w-full table-custom" }
const _hoisted_14 = /*#__PURE__*/_createVNode("th", { class: "text-left" }, null, -1)
const _hoisted_15 = { class: "text-left f-overtime" }
const _hoisted_16 = { class: "text-left f-overtime" }
const _hoisted_17 = { class: "text-left f-overtime" }
const _hoisted_18 = { class: "text-left f-overtime" }
const _hoisted_19 = { class: "font-bold f-schedule" }
const _hoisted_20 = { class: "f-overtime" }
const _hoisted_21 = { class: "f-overtime" }
const _hoisted_22 = { class: "f-overtime" }
const _hoisted_23 = { class: "f-overtime" }
const _hoisted_24 = { class: "font-bold f-schedule" }
const _hoisted_25 = { class: "f-overtime" }
const _hoisted_26 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_27 = { class: "f-overtime" }
const _hoisted_28 = { class: "stamp-editing" }
const _hoisted_29 = { class: "stamp-editing__desc" }
const _hoisted_30 = { class: "box-total-working" }
const _hoisted_31 = { class: "flex mt-2 ml-8 justify-between" }
const _hoisted_32 = { class: "box-time-working flex flex-wrap items-start" }
const _hoisted_33 = { class: "mr-5" }
const _hoisted_34 = { class: "mr-2" }
const _hoisted_35 = { class: "ml-2" }
const _hoisted_36 = { class: "total-working flex items-baseline" }
const _hoisted_37 = { class: "total-working__label" }
const _hoisted_38 = { class: "total-working__time" }
const _hoisted_39 = { class: "flex mt-2 ml-8 justify-between" }
const _hoisted_40 = { class: "box-time-working flex flex-wrap items-start" }
const _hoisted_41 = { class: "mr-5" }
const _hoisted_42 = { class: "mr-2" }
const _hoisted_43 = { class: "ml-2" }
const _hoisted_44 = { class: "total-working flex items-baseline" }
const _hoisted_45 = { class: "total-working__label" }
const _hoisted_46 = { class: "total-working__time" }
const _hoisted_47 = { class: "reason-application" }
const _hoisted_48 = { class: "target-date__desc mb-6" }
const _hoisted_49 = { class: "stamp-button flex justify-center mt-8 flex-col" }
const _hoisted_50 = { class: "button-apply hover:opacity-75" }
const _hoisted_51 = { class: "button-cancel" }
const _hoisted_52 = { class: "target-date__desc" }
const _hoisted_53 = { class: "font-bold pl-5 pt-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Label = _resolveComponent("Label")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Input = _resolveComponent("Input")
  const _component_Select = _resolveComponent("Select")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.t('overtimeRegister.overtimeApplication')), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("p", _hoisted_9, _toDisplayString(_ctx.t('overtimeRegister.targetDate')), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('overtimeRegister.exampleDate')), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("table", _hoisted_13, [
                _createVNode("tr", null, [
                  _hoisted_14,
                  _createVNode("th", _hoisted_15, _toDisplayString(_ctx.t('overtimeRegister.attendanceAtWorkLb')), 1),
                  _createVNode("th", _hoisted_16, _toDisplayString(_ctx.t('overtimeRegister.leavingWork')), 1),
                  _createVNode("th", _hoisted_17, _toDisplayString(_ctx.t('overtimeRegister.rest')), 1),
                  _createVNode("th", _hoisted_18, _toDisplayString(_ctx.t('overtimeRegister.workingTime')), 1)
                ]),
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_19, _toDisplayString(_ctx.t('overtimeRegister.schedule')), 1),
                  _createVNode("td", _hoisted_20, _toDisplayString(_ctx.t('overtimeRegister.timeExample')), 1),
                  _createVNode("td", _hoisted_21, _toDisplayString(_ctx.t('overtimeRegister.timeExample2')), 1),
                  _createVNode("td", _hoisted_22, _toDisplayString(_ctx.t('overtimeRegister.timeExample4')), 1),
                  _createVNode("td", _hoisted_23, _toDisplayString(_ctx.t('overtimeRegister.timeExample')), 1)
                ]),
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_24, _toDisplayString(_ctx.t('overtimeRegister.stampingRecord')), 1),
                  _createVNode("td", _hoisted_25, _toDisplayString(_ctx.t('overtimeRegister.timeExample3')), 1),
                  _hoisted_26,
                  _createVNode("td", _hoisted_27, _toDisplayString(_ctx.t('overtimeRegister.timeExample4')), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("p", _hoisted_29, _toDisplayString(_ctx.t('overtimeRegister.overtimeApplicationTime')), 1),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _createVNode("div", _hoisted_33, [
                      _createVNode(_component_Label, {
                        "text-label": _ctx.t('overtimeRegister.labelCheckin')
                      }, null, 8, ["text-label"])
                    ]),
                    _createVNode("div", _hoisted_34, [
                      _createVNode(_component_DatePicker, {
                        format: "dd-MM-YYYY",
                        width: "120"
                      })
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _createVNode(_component_Input, {
                        placeholder: _ctx.t('overtimeRegister.textDateExample'),
                        type: "time"
                      }, null, 8, ["placeholder"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("p", _hoisted_37, _toDisplayString(_ctx.t('overtimeRegister.totalWorkingHours')), 1),
                    _createVNode("span", _hoisted_38, _toDisplayString(_ctx.t('overtimeRegister.timeExample5')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _createVNode(_component_Label, {
                        "text-label": _ctx.t('overtimeRegister.labelCheckin')
                      }, null, 8, ["text-label"])
                    ]),
                    _createVNode("div", _hoisted_42, [
                      _createVNode(_component_DatePicker, {
                        format: "dd-MM-YYYY",
                        width: "120"
                      })
                    ]),
                    _createVNode("div", _hoisted_43, [
                      _createVNode(_component_Input, {
                        placeholder: _ctx.t('overtimeRegister.textDateExample'),
                        type: "time"
                      }, null, 8, ["placeholder"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_44, [
                    _createVNode("p", _hoisted_45, _toDisplayString(_ctx.t('overtimeRegister.overtime')), 1),
                    _createVNode("span", _hoisted_46, _toDisplayString(_ctx.t('overtimeRegister.timeExample6')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode("p", _hoisted_48, _toDisplayString(_ctx.t('overtimeRegister.ReasonApplication')), 1),
              _createVNode(_component_Select, {
                placeholder: _ctx.t('overtimeRegister.placeholderSelectOvertime'),
                optionsSelect: _ctx.optionReasonApplication,
                "item-text": "text"
              }, null, 8, ["placeholder", "optionsSelect"])
            ])
          ]),
          _createVNode("div", _hoisted_49, [
            _createVNode("button", _hoisted_50, _toDisplayString(_ctx.t('overtimeRegister.buttonApply')), 1),
            _createVNode("button", _hoisted_51, _toDisplayString(_ctx.t('overtimeRegister.buttonCancel')), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("p", _hoisted_52, _toDisplayString(_ctx.t('overtimeRegister.approvalRoute')), 1),
            _createVNode("p", _hoisted_53, _toDisplayString(_ctx.t('overtimeRegister.primaryApproval')), 1)
          ])
        ])
      ])
    ])
  ]))
})